import React from 'react';
import usePageTranslation from '../../../shared/hooks/usePageTranslation';
import LegalPage from '../components/LegalPage';
import LegalSection from '../components/LegalSection';
import LegalContactBlock from '../components/LegalContactBlock';

const Reglement: React.FC = () => {
  const { t, loading } = usePageTranslation('public', 'Reglement');

  if (loading) return null;

  return (
    <LegalPage
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdate={t('lastUpdate')}
      lastUpdateDate={t('lastUpdateDate')}
    >
      <LegalSection number={1} title={t('intro.title')}>
        <p className="text-lg text-gray-300">{t('intro.description')}</p>
      </LegalSection>

      <LegalSection number={2} title={t('general.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('general.description')}</p>
        <ul className="space-y-2">
          {t('general.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={3} title={t('gameplay.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('gameplay.description')}</p>
        <ul className="space-y-2">
          {t('gameplay.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={4} title={t('communication.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('communication.description')}</p>
        <ul className="space-y-2">
          {t('communication.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={5} title={t('team.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('team.description')}</p>
        <ul className="space-y-2">
          {t('team.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={6} title={t('account.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('account.description')}</p>
        <ul className="space-y-2">
          {t('account.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={7} title={t('sanctions.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('sanctions.description')}</p>
        <ul className="space-y-2 mb-4">
          {t('sanctions.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
        <p className="text-sm text-gray-400 italic">{t('sanctions.note')}</p>
      </LegalSection>

      <LegalSection number={8} title={t('updates.title')}>
        <p className="text-lg text-gray-300">{t('updates.description')}</p>
      </LegalSection>

      <LegalSection number={9} title={t('contact.title')}>
        <LegalContactBlock
          description={t('contact.description')}
          discord={t('contact.discord')}
          discordAction={t('contact.discordAction')}
          email={t('contact.email')}
          owner={t('contact.owner')}
        />
      </LegalSection>
    </LegalPage>
  );
};

export default Reglement;
